import { LOAD_DINEIN_SETTINGS_SUCCESS, UPDATE_DINEIN_SETTINGS_SUCCESS, RESET_DINEIN_SETTINGS } from '../../../../actions/types';

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_DINEIN_SETTINGS_SUCCESS:
            return action.payload;
        case UPDATE_DINEIN_SETTINGS_SUCCESS:
            return action.payload;
        case RESET_DINEIN_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/DineInReducer.js